type CheckoutPlan = string | null;

export function getLoginIntroDescription(checkoutPlan: CheckoutPlan, yandexAuthEnabled: boolean): string {
  if (checkoutPlan) {
    return `Войдите, и мы продолжим оформление тарифа ${checkoutPlan}.`;
  }

  return yandexAuthEnabled
    ? 'Выберите Yandex или продолжите по электронной почте.'
    : 'Продолжите по электронной почте.';
}

export function getSignupIntroDescription(checkoutPlan: CheckoutPlan, yandexAuthEnabled: boolean): string {
  if (checkoutPlan) {
    return `Создайте аккаунт и продолжите оформление тарифа ${checkoutPlan}.`;
  }

  return yandexAuthEnabled
    ? 'Создайте аккаунт через Yandex или по электронной почте.'
    : 'Создайте аккаунт по электронной почте.';
}

export function shouldShowYandexAuthCallToAction(yandexAuthEnabled: boolean): boolean {
  return yandexAuthEnabled;
}

export function shouldShowProfileYandexIntegration(
  yandexAuthEnabled: boolean,
  userProvider?: string | null,
  linkedAccounts: string[] = [],
): boolean {
  return yandexAuthEnabled || userProvider === 'yandex' || linkedAccounts.includes('yandex');
}
